<p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)">
    <p-tablist>
        <p-tab value="telaio1"><span>Telaio 1</span></p-tab>
        <p-tab value="telaio2"><span>Telaio 2</span></p-tab>
        <p-tab value="telaio3"><span>Telaio 3</span></p-tab>
        <p-tab value="telaio4"><span>Telaio 4</span></p-tab>
    </p-tablist>

    <p-tabpanels>
        <p-tabpanel value="telaio1">
            <app-misure-telaio
                [form]="form"
                [formReady]="formReady"
                [mode]="mode"
                [normativa]="normativa"
                [deviatoioId]="deviatoioId"
                prefix="telaio1_"
                [sKeys]="['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10', 's11', 's12']"
                [ruleKeys]="['a', 'b', 'c', 'd', 'e', 'f']"
                [extraKeys]="['p', 'q', 'r', 't', 'v', 'z']"
                [isActive]="true"
                [normativa]="getNormativaByTab('1')"
            >
            </app-misure-telaio>
        </p-tabpanel>
        <p-tabpanel value="telaio2">
            <app-misure-telaio
                [form]="form"
                [mode]="mode"
                [normativa]="normativa"
                prefix="telaio2_"
                [sKeys]="['s1', 's2', 's3', 's4', 's5', 's6']"
                [ruleKeys]="['a', 'b', 'c', 'd']"
                [formReady]="formReady"
                [deviatoioId]="deviatoioId"
                [normativa]="getNormativaByTab('2')"
            >
            </app-misure-telaio>
        </p-tabpanel>
        <p-tabpanel value="telaio3">
            <app-misure-telaio
                [form]="form"
                [normativa]="normativa"
                prefix="telaio3_"
                [sKeys]="['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8']"
                [ruleKeys]="['a', 'b', 'c', 'd']"
                [extraKeys]="['p', 'q']"
                [formReady]="formReady"
                [mode]="mode"
                [deviatoioId]="deviatoioId"
                [normativa]="getNormativaByTab('3')"
            >
            </app-misure-telaio>
        </p-tabpanel>
        <p-tabpanel value="telaio4">
            <app-misure-telaio
                [form]="form"
                [mode]="mode"
                [normativa]="normativa"
                prefix="telaio4_"
                [sKeys]="['s1', 's2', 's3', 's4', 's5', 's6']"
                [ruleKeys]="['a', 'b', 'c', 'd']"
                [formReady]="formReady"
                [deviatoioId]="deviatoioId"
                [normativa]="getNormativaByTab('4')"
            >
            </app-misure-telaio>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>
